import SuperAdminTelletsTable from '@/components/super-admin/tellets/SuperAdminTelletsTable';

function SuperAdminTellets() {
  return (
    <main className="flex flex-col w-full h-full">
      <h1 className="mb-2 font-bold">Tellets</h1>
      <SuperAdminTelletsTable />
    </main>
  );
}

export default SuperAdminTellets;
